import LocalStorageService from './local-storage/local-storage.service';

export default class SplashMessage {

	constructor() {
		const message = document.querySelector('.splash-message');
		if (message) {
			const viewed = LocalStorageService.get('splash-message__viewed');
			if (!viewed) {
				LocalStorageService.set('splash-message__viewed', true);
				message.classList.add('splash-message--opened');
				this.onDocumentClick = this.onDocumentClick.bind(this);
				this.onInnerClick = this.onInnerClick.bind(this);
				this.onClose = this.onClose.bind(this);
				const inner = message.querySelector('.splash-message__inner');
				const close = message.querySelector('.splash-message__close');
				document.addEventListener('click', this.onDocumentClick);
				inner.addEventListener('click', this.onInnerClick);
				close.addEventListener('click', this.onClose);
				setTimeout(() => {
					message.classList.add('splash-message--entering');
				}, 100);
			}
		}
	}

	onDocumentClick() {
		this.onClose();
	}

	onInnerClick(event) {
		event.preventDefault();
		event.stopImmediatePropagation();
	}

	onClose() {
		const message = document.querySelector('.splash-message');
		const inner = message.querySelector('.splash-message__inner');
		const close = message.querySelector('.splash-message__close');
		document.removeEventListener('click', this.onDocumentClick);
		inner.removeEventListener('click', this.onInnerClick);
		close.removeEventListener('click', this.onClose);
		message.classList.remove('splash-message--entering');
		message.classList.add('splash-message--exiting');
		setTimeout(() => {
			message.classList.remove('splash-message--opened');
			if (message.parentNode) {
				message.parentNode.removeChild(message);
			}
		}, 600);
	}

}

window.onload = () => {
	const message = new SplashMessage();
};
